import $ from 'jquery';

import RespondService from '../../Services/Respond';
import constants from '../../constants';

const GALLERY_IMAGE_SELECTOR = '.block-gallery__row__column__image__img';
const GALLERY_IMAGE_CAPTION_SELECTOR = '.block-gallery__row__column__image__caption';
const RESIZE_DEBOUNCE_TIMER = 100;

export default class GalleryHandler {
    constructor() {
        this.resizeDebouncer = null;
        this.setupEvents();
        this.refresh();
    }

    setupEvents() {
        $(window).on('resize', (ev) => { this.onResize(ev); })
    }

    onResize() {
        clearInterval(this.resizeDebouncer);

        this.resizeDebouncer = setTimeout(() => {
            this.refresh();
        }, RESIZE_DEBOUNCE_TIMER);
    }

    refresh() {
        if(RespondService.from(constants.BREAKPOINT_M)) {
            this.syncWidths()
        } else {
            this.resetElements();
        }
    }

    syncWidths() {
        $(GALLERY_IMAGE_SELECTOR).each((index, imageElement) => {
            const image = $(imageElement)
            const width = image.width();
            const caption = image.siblings(GALLERY_IMAGE_CAPTION_SELECTOR);

            caption.css('width', width);
        });
    }

    resetElements() {
        $(GALLERY_IMAGE_CAPTION_SELECTOR).removeAttr('style');
    }

}


// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/App/Blocks/GalleryHandler.js